import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../api/requestProcessor";
import { deleteConsultant } from "../../api/consultantsAPI";
import { useContext } from "react";
import { AppContext } from "../../context/AppProvider";
import { getErrorMessage } from "../../util/helper";

export default function DeleteConsultant({
  deleteDialog,
  hideDeleteDialog,
  consultant,
}) {
  const { toast } = useContext(AppContext);

  const { mutate, isPending } = useMutation({
    mutationFn: deleteConsultant,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["consultants"] });
      hideDeleteDialog();
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Consultant Deleted",
        life: 3000,
      });
    },
    onError: (error) => {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: getErrorMessage(error),
        life: 3000,
      });
    },
  });

  const handleDeleteConsultant = () => {
    mutate({ consultantId: consultant._id });
  };

  const deleteProductDialogFooter = (
    <>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={handleDeleteConsultant}
        loading={isPending}
      />
    </>
  );

  return (
    <Dialog
      visible={deleteDialog}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header="Confirm"
      modal
      footer={deleteProductDialogFooter}
      onHide={hideDeleteDialog}
      className="mx-2"
    >
      <div className="confirmation-content">
        <i
          className="pi pi-exclamation-triangle mr-3"
          style={{ fontSize: "2rem" }}
        />
        {consultant && (
          <span>
            Are you sure you want to delete <b>{consultant.role}</b>?
          </span>
        )}
      </div>
    </Dialog>
  );
}
